import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Storage } from '@ionic/storage';
import { BusinessProductPaymentManagerHandler } from '../../providers/business-product-payment-handler';
import { Globals } from '../../providers/globals';
import { ProductPaymentCheckoutHandler } from '../../providers/product-payment-checkout-handler';

@Component({
  selector: 'page-business-product-detail',
  templateUrl: 'business-product-detail.html',
})
export class BusinessProductDetailPage {
	product: any;
	modifiers: any = [];
	selectedModifiers: any = [];
	loader: any;
	filePath: any;
	isLoading: boolean = false;
	loadingMsg: any = "Loading...";
	userIsLoading: boolean = false

	params: any = {
		subcategoryId: null,
		page: 1,
		size: 20,
		cb: null
	}

	filteredProducts: any = [{
		Count: 0,
		Initial: ''
	}];

	selectedTotal: any = 0;
	selectedProducts: any = [];

	hasProducts: boolean = false;

  	constructor(  		
  		private toastCtrl: ToastController,
		public navCtrl: NavController, 
		public viewCtrl: ViewController,
		public navParams: NavParams,
		private formBuilder: FormBuilder,
		public managerHandler: BusinessProductPaymentManagerHandler,
		public checkoutHandler: ProductPaymentCheckoutHandler,	
		public storage: Storage,
		public loadingCtrl: LoadingController,
		public alertCtrl: AlertController,
		public globals: Globals,
		public actionSheetCtrl: ActionSheetController,
		public _DomSanitizer: DomSanitizer
		) {
  		this.filePath = this.globals.fileUrl;

  		this.product = navParams.get('product');
  	}

  	ionViewWillEnter() {
		if(this.product.Id){
	   		this.load(null);
	    } 
	}

	load(cb){
		this.isLoading = true;

		this.params.id = this.product.Id

		this.params.cb = (results)=>{

			this.modifiers = results;

			if(this.product.IndexId){
				this.prepProduct()
			}

		  	this.isLoading = false;

			if(typeof cb == "function")
				cb()			
		}

		this.managerHandler.getModifiersByProductId(this.params)
	}

	cancel(){

		this.selectedTotal = 0;

   		// this.viewCtrl.dismiss(this.selectedProducts);

   		this.viewCtrl.dismiss();

	}

	addToOrder(){

		this.selectedProducts = [];

		for (var i = 0; i < this.product.Count; i++){
			this.selectedProducts.push(this.product)
		}

		this.selectedTotal = 0;

   		this.viewCtrl.dismiss(this.selectedProducts);

	}

	addProduct($e, product) {

		this.selectProduct(null, product)
	}

	selectProduct($e, product) {

		product.Count = product.Count ? product.Count + 1 : 1;

		product.Modifiers = this.selectedModifiers;

		this.selectedTotal += product.Price;

		// this.selectedProducts.push(product)
	}

	removeProduct($e, product) {

		this.selectedTotal -= product.Price;

		product.Count = product.Count ? product.Count - 1 : 0;

		if(product.Count == 0) {
			this.checkoutHandler.order.products = this.checkoutHandler.order.products.filter(function(item) {
			    return item.IndexId != product.IndexId;
			});

			this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products = this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products.filter(function(item) {
			    return item.IndexId != product.IndexId;
			});
		}
	}

	selectModifier($e, modifier) {
		modifier.IsSelected = modifier.IsSelected ? !modifier.IsSelected : true;

		if(modifier.IsSelected)
			this.selectedModifiers.push(modifier)
		else
			this.selectedModifiers = this.selectedModifiers.filter(function(item) {
			    return item.Id != modifier.Id;
			});

		this.product.Modifiers = this.selectedModifiers;

		// for(let product of this.selectedProducts){
		// 	product.Modifiers = this.selectedModifiers;
		// }
	}

	prepProduct(){
		// for (var i = 0; i < this.product.Count; i++){
		// 	this.selectedProducts.push(this.product)
		// }

		this.selectedProducts = []

		this.selectedTotal += this.product.Price * this.product.Count;

		if(this.product.Modifiers.length > 0) {

			this.selectedModifiers = this.product.Modifiers;

			for(let modifier of this.product.Modifiers){

				var modifierToSelect = this.modifiers.filter(function(item) {
					    return item.Id == modifier.Id;
					});

				if(modifierToSelect.length > 0)
					modifierToSelect[0].IsSelected = true
			}

		}
	}
}


// WEBPACK FOOTER //
// ./src/pages/business-product-detail/business-product-detail.ts